import PropTypes from 'prop-types';

import GeneralControllers from './GeneralControllers';
import StyleControllers from './StyleControllers';
import AxisControllers from './AxisControllers';
import LegendControllers from './LegendControllers';
import InteractivityController from './InteractivityController';
import MarkerControllers from './MarkerControllers';

const Controllers = ({
  config = undefined,
  data = undefined,
  handle = () => {},
  extend = '',
  setExtend = () => {},
  selectedColumn = undefined,
  isGlobalThemeActive = false,
  isGlobalFontActive = false,
  selectedDrilldown = undefined,
  forDrilldown = false,
}) => (
  <>
    {[
      GeneralControllers,
      StyleControllers,
      AxisControllers,
      LegendControllers,
      InteractivityController,
      MarkerControllers,
    ].map((Group) => (
      <Group
        key={Group.name}
        handle={handle}
        config={config}
        data={data}
        extend={extend}
        setExtend={setExtend}
        selectedColumn={selectedColumn}
        isGlobalThemeActive={isGlobalThemeActive}
        isGlobalFontActive={isGlobalFontActive}
        selectedDrilldown={selectedDrilldown}
        forDrilldown={forDrilldown}
      />
    ))}
  </>
);

Controllers.propTypes = {
  config: PropTypes.shape({}),
  data: PropTypes.shape({}),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  selectedColumn: PropTypes.shape({}),
  isGlobalThemeActive: PropTypes.bool,
  isGlobalFontActive: PropTypes.bool,
  selectedDrilldown: PropTypes.shape({}),
  forDrilldown: PropTypes.bool,
};

export default Controllers;
